// extracted by mini-css-extract-plugin
export default {"subtitle":"empty-cart__subtitle__p0dQ7"};